import Image from 'next/image'
import { cn } from '@/lib/utils'

interface LogoProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'
  className?: string
  showText?: boolean
  textClassName?: string
}

const sizeMap = {
  xs: 16,
  sm: 24,
  md: 32,
  lg: 40,
  xl: 48,
  '2xl': 64
}

export function Logo({ size = 'md', className, showText = true, textClassName }: LogoProps) {
  const dimension = sizeMap[size]

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <div className="relative flex-shrink-0">
        <Image
          src="/InnOGyanlogo.png"
          alt="InnOGyan Logo"
          width={dimension}
          height={dimension}
          className="object-contain"
          priority
        />
      </div>
      {showText && (
        <span className={cn('font-bold', textClassName)}>
          InnOGyan
        </span>
      )}
    </div>
  )
}
